import { useGetAreasHistory } from '../api/useGetAreasHistory'
import styles from './AreasViewHistory.module.scss'
import { Area } from './components/Area'
import { useAreaStore } from '@/modules/Areas'
import { Loader } from '@/ui/Loader'

export const AreasViewHistory = () => {
    const { data: areas, isPending } = useGetAreasHistory()
    const { selectedAreaCode } = useAreaStore()

    const filteredAreas =
        selectedAreaCode === 'all'
            ? areas
            : selectedAreaCode === 'night'
              ? areas?.map((area) => ({ ...area, workstations: area.workstations.filter((ws) => ws.isNightNetwork) }))
              : areas?.filter((area) => area.code === selectedAreaCode)

    if (isPending) {
        return <Loader />
    }

    return <div className={styles.areasView}>{filteredAreas?.map((area) => <Area key={area.code} area={area} />)}</div>
}
